// src/config/blockThemes.js
const blockThemes = [
  {
      style: {
        '--theme-color': 'white',
        '--theme-high-contrast-color': 'var(--blue)',
        '--theme-foreground-color': 'var(--charcoal)',
        '--theme-low-contrast-foreground-color': 'var(--lightblue)',
        '--link-foreground-color': 'var(--blue)',
      },
      name: 'default',
      label: 'Default',
    },
    {
      style: {
        '--theme-color': 'var(--lightgrey)',
        '--theme-high-contrast-color': 'var(--charcoal)',
        '--theme-foreground-color': 'var(--charcoal)',
        '--theme-low-contrast-foreground-color': 'var(--charcoal)',
        '--link-foreground-color': 'var(--blue)',
      },
      name: 'lightgrey',
      label: 'Light Grey',
    },
];

export default blockThemes;
